<template>
  <div class="update-player">
    <div style="padding: 16px 16px 0 16px;">
      <div class="project">
        <div class="top">
          <div class="left">
            <div class="group">
              <span class="entryType" v-if="project.publicSignUp === 0 && project.allowTeamSignup === 1">邀请</span>
              <span class="group-name"> {{ project.group }}</span>
            </div>
            <div class="row">
              <div class="base-box" style="margin-right: 6px">
                <span v-if="project.unitType === 0" style="font-size: 12px; color: #FF652A;">队</span>
                <span v-else-if="project.unitType === 1" style="font-size: 12px; color: #FF652A;">人</span>
                <span v-else style="font-size: 12px; color: #FF652A;">多</span>
              </div>
              <div class="base-box" v-if="project.genderLimit == 1" style="margin-right: 6px">
                <img src="../../../assets/boy.png" style="width: 20px; height: 20px;">
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 2" style="margin-right: 6px">
                <img src="../../../assets/girl.png" style="width: 20px; height: 20px;">
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 0" style="margin-right: 6px; width: 34px;">
                <span style="font-size: 12px; color: #FF652A;">男/女</span>
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 3" style="margin-right: 6px; width: 30px;">
                <span style="font-size: 12px; color: #FF652A;">不限</span>
              </div>
              <div class="info">
                参赛年龄：
                <span v-if="project.isOpenAgeLimit === 1">
                  {{ getFormatDate(project.maxAge) }}
                  {{ project.maxAge && project.minAge ? '~' : '' }}
                  {{ getFormatDate(project.minAge) }}
                </span>
                <span v-else>不限</span>
              </div>
            </div>
            <div class="row">
              <div class="info">选手人数：{{ project.teamMemberLeastCount }} ～ {{ project.teamMemberLimitCount }}</div>
            </div>
            <div v-if="project.isOpenCharge === 1">
              <div class="row">
                <div class="info">收费说明：{{ project.feeDescription }}</div>
              </div>
              <div class="row">
                <div class="info">收费方式：{{ getFeeMethodsLabel(project.feeMethod) }}</div>
              </div>
            </div>
          </div>
          <!--          <div class="right">-->
          <!--            <img src="../../../assets/right.png" style="width: 16px; height: 16px;" alt="">-->
          <!--          </div>-->
        </div>
        <div class="line"></div>
        <div class="bottom1">
          <div class="row">
            <div style="display: flex">
              <div class="col" v-if="project.isOpenCharge === 1 && project.feeMethod !== 0" style="margin-right: 8px;">
                <div class="icon">费</div>
                <div class="price">
                  <span v-if="project.feeAmount"> ¥{{ (project.feeAmount / 100).toFixed(2) }}</span>
                  <span v-else>¥0.00</span>
                </div>
              </div>
              <!--              <div class="col">-->
              <!--                <div class="icon">押</div>-->
              <!--                <div class="price" >-->
              <!--                  <span v-if="project.deposit">¥{{ (project.deposit / 100).toFixed(2) }}</span>-->
              <!--                  <span v-else>¥0.00</span>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <div class="col">
              <div class="num" v-if="project.isOpenTeamLimit === 1">剩余名额：{{ project.teamLimitCount - project.teamCount >=
                0 ? (project.teamLimitCount - project.teamCount) : 0 }}队</div>
              <div class="num" v-else>不限</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-form ref="playerForm" input-align="right" error-message-align="right">
      <div class="title">
        <div class="icon"></div>
        <span>个人信息</span>
      </div>
      <van-field label="姓名" v-model="player.trueName" placeholder="请输入名称"
        :rules="[{ required: true, message: '请输入名称' }]"></van-field>
      <van-field v-if="playerCheckboxes.IDCard" label="证件类型" v-model="player.certTypeValue" placeholder="请选择证件类型" readonly
        clickable @click="showCertTypeFun" :rules="[{ required: true, message: '请选择证件类型' }]"></van-field>
      <van-field v-if="playerCheckboxes.IDCard" label="证件号码" v-model="player.IDCardNo" placeholder="请输入证件号码"
        :rules="[{ required: true, message: '请输入证件号码' }, { validator: checkIDCardNo, message: '请输入正确的证件号码' }]"></van-field>
      <van-field v-if="playerCheckboxes.mobile" label="联系电话" v-model="player.mobile" placeholder="请输入联系电话"
        :rules="[{ required: true, message: '请输入联系电话' }, { validator: checkMobile, message: '请输入正确的联系电话' }]"></van-field>
      <van-field v-if="playerCheckboxes.gender" label="性别" v-model="player.gender"
        :rules="[{ required: true, message: '请选择性别' }]">
        <template #input>
          <van-radio-group v-model="player.gender" direction="horizontal">
            <van-radio name="1" checked-color="#FF6010" icon-size="16px"
              :disabled="checkIDCardNoDis(player.IDCardNo)">男</van-radio>
            <van-radio name="2" checked-color="#FF6010" icon-size="16px"
              :disabled="checkIDCardNoDis(player.IDCardNo)">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-if="playerCheckboxes.bmBirthday" label="出生年月" v-model="player.bmBirthdayValue" placeholder="请选择出生年月"
        readonly clickable @click="showBirthdayFun" :rules="[{ required: true, message: '请选择出生年月' }]"></van-field>
      <van-field v-if="playerCheckboxes.avatar" label="报名照" :rules="[{ required: true, message: '请上传报名照' }]">
        <template #input>
          <van-uploader v-model="player.avatarList" max-count="1" :after-read="uploadAvatar" @delete="deleteAvatar" />
        </template>
      </van-field>
      <van-field v-if="playerCheckboxes.nationality" label="国籍" v-model="player.nationality" placeholder="请输入国籍"
        :rules="[{ required: true, message: '请输入国籍' }]"></van-field>
      <van-field v-if="playerCheckboxes.IDCardPhotoA" label="身份证/护照正面"
        :rules="[{ required: true, message: '请上传身份证/护照正面' }]">
        <template #input>
          <van-uploader v-model="player.IDCardPhotoAList" max-count="1" :after-read="uploadIDCardPhotoA"
            @delete="deleteIDCardPhotoA" />
        </template>
      </van-field>
      <van-field v-if="playerCheckboxes.IDCardPhotoB" label="身份证/护照背面"
        :rules="[{ required: true, message: '请上传身份证/护照背面' }]">
        <template #input>
          <van-uploader v-model="player.IDCardPhotoBList" max-count="1" :after-read="uploadIDCardPhotoB"
            @delete="deleteIDCardPhotoB" />
        </template>
      </van-field>
      <van-field v-if="playerCheckboxes.number" label="球衣号码" v-model="player.number" placeholder="请输入球衣号码"
        :rules="[{ required: true, message: '请输入球衣号码' }]"></van-field>
      <van-field v-if="playerCheckboxes.position" label="场上位置" v-model="player.position" placeholder="请输入场上位置"
        :rules="[{ required: true, message: '请输入场上位置' }]"></van-field>
      <van-field v-if="playerCheckboxes.emergencyContactName" label="紧急联系人" v-model="player.emergencyContactName" placeholder="请输入紧急联系人"
        :rules="[{ required: true, message: '请输入紧急联系人' }]"></van-field>
      <van-field v-if="playerCheckboxes.isProfessionalPlayer" label="是否职业球员" v-model="player.isProfessionalPlayer"
        :rules="[{ required: true, message: '请选择是否是职业球员' }]">
        <template #input>
          <van-radio-group v-model="player.isProfessionalPlayer" direction="horizontal">
            <van-radio name="0" checked-color="#FF6010" icon-size="16px">否</van-radio>
            <van-radio name="1" checked-color="#FF6010" icon-size="16px">是</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-if="playerCheckboxes.high" label="身高" v-model="player.high" placeholder="请输入身高（CM）"
        :rules="[{ required: true, message: '请输入身高（CM）' }]"></van-field>
      <van-field v-if="playerCheckboxes.weight" label="体重" v-model="player.weight" placeholder="请输入体重（KG）"
        :rules="[{ required: true, message: '请输入体重（KG）' }]"></van-field>
      <van-field v-if="playerCheckboxes.bmEmail" label="邮箱地址" v-model="player.bmEmail" placeholder="请输入邮箱地址"
        :rules="[{ required: true, message: '请输入邮箱地址' }]"></van-field>
      <van-field v-if="playerCheckboxes.jerseyName" label="球衣姓名" v-model="player.jerseyName" placeholder="请输入球衣姓名"
        :rules="[{ required: true, message: '请输入球衣姓名' }]"></van-field>
      <van-field v-if="playerCheckboxes.jerseysSize" label="球衣尺码" v-model="player.jerseysSize" placeholder="请输入球衣尺码"
        :rules="[{ required: true, message: '请输入球衣尺码' }]"></van-field>
      <van-field v-if="playerCheckboxes.shoesSize" label="球鞋尺码" v-model="player.shoesSize" placeholder="请输入球鞋尺码"
        :rules="[{ required: true, message: '请输入球鞋尺码' }]"></van-field>
      <van-field v-if="playerCheckboxes.qualificationFile" label="资质证明" :rules="[{ required: true, message: '请上传资质证明' }]"
        input-align="left" style="display: block;">
        <template #input>
          <div class="my-imgs">
            <div style="font-size: 12px;margin-bottom: 6px;">最多上传5张图片</div>
            <div style="padding-left: 12px;">
              <van-uploader v-model="player.qualificationFileList" max-count="5" :after-read="uploadQualificationFile"
                @delete="deleteQualificationFile" />
            </div>
          </div>
        </template>
      </van-field>
      <van-field v-if="playerCheckboxes.insureFile" label="保险证明" :rules="[{ required: true, message: '请上传保险证明' }]">
        <template #input>
          <van-uploader v-model="player.insureFileList" max-count="1" :after-read="uploadInsureFile"
            @delete="deleteInsureFile" />
        </template>
      </van-field>
      <van-field v-if="playerCheckboxes.school" label="就读学校" v-model="player.school" placeholder="请输入就读学校"
        :rules="[{ required: true, message: '请输入就读学校' }]"></van-field>
      <van-field v-if="playerCheckboxes.remark" label="备注" v-model="player.remark" placeholder="请输入备注"
        :rules="[{ required: true, message: '请输入备注' }]"></van-field>
      <van-field v-if="playerCheckboxes.domicileAreaId" label="所属城市" v-model="player.domicileAreaName" readonly
        @click="showArea = true" placeholder="请选择所属城市" :rules="[{ required: true, message: '请选择所属城市' }]"></van-field>
      <van-field v-if="playerCheckboxes.ethnicity" label="民族" v-model="player.ethnicity" placeholder="请输入民族"
        :rules="[{ required: true, message: '请输入民族' }]"></van-field>
      <van-field v-if="playerCheckboxes.title" label="队内职务" v-model="player.title" placeholder="请输入队内职务"
        :rules="[{ required: true, message: '请输入队内职务' }]"></van-field>
      <van-field v-if="playerCheckboxes.enterprise" label="工作单位" v-model="player.enterprise" placeholder="请输入工作单位"
        :rules="[{ required: true, message: '请输入工作单位' }]"></van-field>
      <van-field v-if="playerCheckboxes.post" label="岗位" v-model="player.post" placeholder="请输入岗位"
        :rules="[{ required: true, message: '请输入岗位' }]"></van-field>
      <van-field v-if="playerCheckboxes.guardianName" label="家长姓名" v-model="player.guardianName" placeholder="请输入家长姓名"
        :rules="[{ required: true, message: '请输入家长姓名' }]"></van-field>
      <van-field v-if="playerCheckboxes.guardianMobile" label="家长手机号" v-model="player.guardianMobile"
        placeholder="请输入家长手机号" :rules="[{ required: true, message: '请输入家长手机号' }]"></van-field>
      <van-field v-if="playerCheckboxes.joinTeam" label="所属球队" v-model="player.joinTeam" placeholder="请输入所属球队"
        :rules="[{ required: true, message: '请输入所属球队' }]"></van-field>
    </van-form>
    <div style="height: 80px;"></div>
    <div class="bottom">
      <van-button type="info" round block @click="savePlayer" style="height: 50px; background-color: #191919;">
        <span style="color: #FFFFFF;">保 存</span>
      </van-button>
    </div>
    <div class="popup">
      <van-popup v-model="showBirthday" position="bottom" :style="{ height: '50%' }">
        <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
          @cancel="cancelBirthdayTime" @confirm="confirmBirthdayTime" />
      </van-popup>
      <van-popup v-model="showCertType" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择证件类型" show-toolbar :columns="certTypeColumns" @confirm="onConfirmCertType"
          @cancel="onCancelCertType" />
      </van-popup>
      <van-popup v-model="showArea" round position="bottom">
        <van-cascader v-model="player.domicileAreaId" title="请选择所在地区" :options="options" :field-names="fieldNames"
          @close="showArea = false" @change="onChange" @finish="onFinish" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { DateUtil, QNImageUtil, RegExpr, ToolUtil } from "@/utils";
import Vue from 'vue'
import {
  Form, Field, Icon, Popup, Loading, Overlay, Dialog, Uploader,
  RadioGroup, Radio, DatetimePicker, Button, Picker, Toast, Cascader
} from 'vant'
import { getQiniuUploadToken, uploadImage } from "@/api/qiniu";
import {
  getBMMatchTeamPlayer,
  updateBMMatchTeamPlayer,
  getAreaTreeList,
  getBMMatchTeamSignup
} from "@/api/match";
import { getPassport } from "@/libs/passport";
import { feeMethodOptions, orderStatusOptions } from "@/config";
Vue.use(Form).use(Field).use(Icon).use(Popup)
  .use(Loading).use(Overlay).use(Dialog).use(Uploader).use(RadioGroup)
  .use(Radio).use(Button).use(DatetimePicker).use(Picker).use(Cascader)

const certTypeOption = [
  { value: 1, label: '身份证' },
  { value: 11, label: '学籍卡' },
  { value: 2, label: '护照' },
  { value: 3, label: '港澳通行证' },
  { value: 4, label: '台胞证' },
  { value: 5, label: '港澳台回乡证' }
]
const certTypeColumns = ['身份证', '学籍卡', '护照', '港澳通行证', '台胞证', '港澳台回乡证']

export default {
  data() {
    return {
      showDialog: false,
      team: {},
      certTypeColumns: certTypeColumns,
      showBirthday: false,
      showCertType: false,
      qiniuToken: '',
      players: [],
      player: {},
      project: {},
      minDate: '',
      maxDate: '',
      currentDate: '',
      defaultCertIndex: 0,
      options: [],
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'kids',
      },
      showArea: false,
      playerCheckboxes: {},
      title: '',
      unionMatchId: '',
      projectId: '',
      teamId: '',
      playerId: ''
    }
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId
        this.playerId = this.$route.query.playerId
        this.getAreaTreeList()
        this.getQiniuUploadToken()
      }
    })
  },
  watch: {
    'player.IDCardNo': {
      handler() {
        if (RegExpr.isIdCard(this.player.IDCardNo)) {
          const player = JSON.parse(JSON.stringify(this.player))
          player.gender = '' + ToolUtil.getSex(player.IDCardNo)
          player.bmBirthdayValue = ToolUtil.getBirthday(player.IDCardNo)
          player.bmBirthday = DateUtil.parseDateTime(ToolUtil.getBirthday(this.player.IDCardNo), '{y}-{m}-{d}T00:00:00+0800')
          this.player = player
        }
      }
    },
    'player.gender': {
      handler() {
        if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
          Toast({ type: 'fail', message: '性别异常' })
        }
      }
    }
  },
  methods: {
    getBMMatchTeamPlayer() {
      const params = {
        id: this.playerId
      }
      getBMMatchTeamPlayer(params).then(res => {
        if (res) {
          const { data } = res
          console.log(data)
          const player = data.player || {}
          player.bmBirthdayValue = player.bmBirthday && this.getFormatDate(player.bmBirthday) || ''
          // player.certTypeValue = player.certType && certTypeColumns[player.certType - 1] || '身份证'
          // if (player.certTypeValue === '身份证') {
          //   player.certType = 1
          // }
          player.certTypeValue = player.certType && certTypeOption.find(i => i.value === player.certType)?.label || '身份证'
          if (player.certTypeValue === '身份证') {
            player.certType = 1
          }
          player.avatarList = player.avatar && [{ url: QNImageUtil.imageView(player.avatar), isImage: true }] || []
          player.IDCardPhotoAList = player.IDCardPhotoA && [{ url: QNImageUtil.imageView(player.IDCardPhotoA), isImage: true, hash: player.IDCardPhotoA }] || []
          player.IDCardPhotoBList = player.IDCardPhotoB && [{ url: QNImageUtil.imageView(player.IDCardPhotoB), isImage: true, hash: player.IDCardPhotoB }] || []
          if (player.qualificationFile && player.qualificationFile.length > 0) {
            const a = player.qualificationFile.split(',') || []
            player.qualificationFileList = []
            a.forEach(item => {
              player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
            })
          } else {
            player.qualificationFileList = []
          }
          if (player.insureFile && player.insureFile.length > 0) {
            const a = player.insureFile.split(',') || []
            player.insureFileList = []
            a.forEach(item => {
              player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
            })
          } else {
            player.insureFileList = []
          }
          const a = []
          this.getAreaInfo(player.domicileAreaId, this.options, a)
          a.reverse()
          player.domicileAreaName = a.join('/')
          this.player = player
        }
      })
    },
    getAreaInfo(areaId, options, a) {
      if (!areaId) return ''
      for (let i = 0; i < options.length; i++) {
        if (options[i].id === areaId) {
          a.push(options[i].name)
          return true
        } else if (options[i].kids) {
          const b = this.getAreaInfo(areaId, options[i].kids, a)
          if (b) {
            a.push(options[i].name)
            return true
          }
        }
      }
      return false
    },
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },
    getPaymentStatus(value) {
      const order = orderStatusOptions.find(o => o.value === value)
      return order?.label || ''
    },
    getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    onChange({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      console.log(this.player.domicileAreaName, this.player.domicileAreaId)
    },
    onFinish({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      this.showArea = false
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          console.log(this.options);
          this.getBMMatchTeamSignup()
          this.getBMMatchTeamPlayer()
        }
      })
    },
    goEntryList() {
      this.$router.push('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          const project = data.match
          this.agreementList = data.agreement || []
          this.minDate = this.project.maxAge ? new Date(this.project.maxAge) : new Date(1970, 1, 1)
          this.maxDate = this.project.minAge ? new Date(this.project.minAge) : new Date()
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          const playerCheckboxes = {}
          psfs.forEach(psf => {
            playerCheckboxes[psf] = true
          })
          this.project = project
          this.playerCheckboxes = playerCheckboxes
          this.team = data.team || {}
        }
      })
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    checkIDCardNoDis(value) {
      return RegExpr.isIdCard(value)
    },
    showBirthdayFun() {
      if (RegExpr.isIdCard(this.player.IDCardNo)) return
      this.showBirthday = true
    },
    checkIDCardNo(value) {
      if (this.player.certType === 1) return RegExpr.isIdCard(value)
      return true
    },
    showCertTypeFun() {
      this.showCertType = true
    },
    onConfirmCertType(value) {
      this.player.certTypeValue = value
      const item = certTypeOption.find(i => i.label === value)
      this.player.certType = item.value
      this.showCertType = false
    },
    onCancelCertType() {
      const index = this.roleColumns.findIndex(item => item === this.player.certTypeValue)
      this.defaultCertIndex = index > -1 ? index : 0
      this.showCertType = false
    },
    uploadAvatar(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.avatar = res.hash
      })
    },
    deleteAvatar() {
      this.player.avatar = this.team.avatarList.join(',') ?? ''
    },
    uploadIDCardPhotoA(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoA = res.hash
      })
    },
    deleteIDCardPhotoA() {
      this.player.IDCardPhotoA = this.team.IDCardPhotoAList.join(',') ?? ''
    },
    uploadIDCardPhotoB(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoB = res.hash
      })
    },
    deleteIDCardPhotoB() {
      this.player.IDCardPhotoB = this.team.IDCardPhotoBList.join(',') ?? ''
    },
    uploadQualificationFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.qualificationFile && player.qualificationFile.length > 0) {
          player.qualificationFile = player.qualificationFile + ',' + res.hash
        } else {
          player.qualificationFile = res.hash
        }
        const a = player.qualificationFile.split(',')
        player.qualificationFileList = []
        a.forEach(item => {
          player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteQualificationFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.qualificationFileList.forEach(item => {
        a.push(item.hash)
      })
      player.qualificationFile = a.join(',')
      this.player = player
    },
    uploadInsureFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.insureFile && player.insureFile.length > 0) {
          player.insureFile = player.insureFile + ',' + res.hash
        } else {
          player.insureFile = res.hash
        }
        const a = player.insureFile.split(',') || []
        player.insureFileList = []
        a.forEach(item => {
          player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteInsureFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.insureFileList.forEach(item => {
        a.push(item.hash)
      })
      player.insureFile = a.join(',')
      this.player = player
    },
    savePlayer() {
      this.$refs.playerForm.validate().then(() => {
        const params = JSON.parse(JSON.stringify(this.player))
        params.id = this.playerId
        params.matchId = this.projectId
        delete params.avatarList
        delete params.IDCardPhotoAList
        delete params.IDCardPhotoBList
        delete params.qualificationFileList
        delete params.insureFileList
        delete params.showPlayerInfo
        delete params.domicileAreaName
        delete params.bmBirthdayValue
        delete params.certTypeValue
        updateBMMatchTeamPlayer(params).then(res => {
          if (res) {
            this.$router.go(-1)
          }
        })
      })
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    confirmBirthdayTime(value) {
      this.player.bmBirthdayValue = DateUtil.parseDateTime(value, '{y}-{m}-{d}')
      this.player.bmBirthday = DateUtil.parseDateTime(value, '{y}-{m}-{d}T00:00:00+0800')
      this.showBirthday = false
    },
    cancelBirthdayTime() {
      this.showBirthday = false
    }
  }
}
</script>

<style lang="scss">
.update-player {
  .notice {
    display: flex;
    align-items: center;
    height: 32px;
    font-size: 11px;
    background-color: #FEF8F6;
    color: #FF652A;
    padding: 0 8px;

    .info {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .team-info {
    padding: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .name {
      font-size: 16px;
      line-height: 30px;
      color: #333333;
    }

    .group {
      font-size: 14px;
      line-height: 30px;
      color: #8d8d8d;
    }

    .player-num {
      font-size: 14px;
      line-height: 30px;
      color: #333333;
    }
  }

  .project {
    padding: 16px 12px 12px 12px;
    margin-bottom: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .top {
      display: flex;
      justify-content: space-between;

      .left {
        .group {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;

          .entryType {
            background-color: #FF652A;
            color: #FFFFFF;
            border-radius: 2px;
            display: inline-block;
            height: 20px;
            width: 32px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
          }

          .group-name {
            font-size: 16px;
            height: 20px;
            color: #333333;
          }
        }

        .row {
          display: flex;
          align-items: center;
          padding: 0 0 5px 0;

          .base-box {
            width: 20px;
            height: 20px;
            background-color: #FBEFEA;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .info {
            font-size: 12px;
            color: #8C8C8C;
          }

          .col {
            display: flex;
            height: 20px;
            width: 82px;
            line-height: 20px;

            .icon {
              width: 20px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background-color: #1565FC;
              font-size: 12px;
              font-weight: 500;
              color: #FFFFFF;
            }
          }
        }
      }

      .right {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .line {
      margin: 4px 0 10px 0;
      height: 1px;
      background-color: #F3F3F3;
    }

    .bottom1 {
      .row {
        display: flex;
        justify-content: space-between;

        .base-box {
          width: 20px;
          height: 20px;
          background-color: #FBEFEA;
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .info {
          font-size: 12px;
          color: #8C8C8C;
        }

        .col {
          display: flex;
          height: 20px;
          line-height: 20px;

          .icon {
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background-color: #1565FC;
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
          }

          .price {
            height: 20px;
            width: 68px;
            text-align: center;
            line-height: 20px;
            background-color: #E5EDFF;
            font-size: 12px;
            font-weight: 500;
            color: #1565FC;
            border-radius: 0 3px 3px 0;
          }

          .num {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }
  }

  .title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    padding: 25px 0 13px 0;
    margin: 0 16px;
    border-bottom: 0.5px #EEEEEE solid;

    .icon {
      width: 2px;
      height: 12px;
      background-color: #7CCD19;
      margin-right: 6px;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}

.agreement-top {
  background-color: #fff;
  padding: 12px 12px 0 12px;

  .agreement-title {
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .hint {
    text-align: center;
    font-size: 16px;
    color: #8C8C8C;
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}
</style>
